import React, { useEffect, useRef } from "react";
import { User, Plane } from "lucide-react";

function Bubble({ m }) {
  const mine = m.role === "user";
  return (
    <div className={`flex gap-3 ${mine ? "flex-row-reverse" : ""}`} data-testid={`chat-message-${m.role}`}>
      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${mine ? "bg-slate-200 text-slate-600" : "bg-blue-600 text-white"}`}>
        {mine ? <User className="h-4 w-4" /> : <Plane className="h-4 w-4" />}
      </span>
      <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${mine ? "bg-blue-600 text-white" : "border border-slate-200 bg-white text-slate-700"}`}>{m.text}</div>
    </div>
  );
}

function Typing() {
  return (
    <div className="flex gap-3" data-testid="chat-typing">
      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 text-white"><Plane className="h-4 w-4" /></span>
      <div className="flex items-center gap-1 rounded-2xl border border-slate-200 bg-white px-4 py-3">
        {[0, 150, 300].map((d) => <span key={d} className="h-2 w-2 animate-bounce rounded-full bg-slate-300" style={{ animationDelay: `${d}ms` }} />)}
      </div>
    </div>
  );
}

export default function MessageList({ messages, loading }) {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);
  return (
    <div className="flex-1 space-y-4 overflow-y-auto pb-4">
      {messages.map((m) => <Bubble key={m.id} m={m} />)}
      {loading && <Typing />}
      <div ref={endRef} />
    </div>
  );
}
